<template>
  <div class="wrapper">
    <div class="web-contain">
      <router-view></router-view>
    </div>

    <web-footer></web-footer>
  </div>
</template>

<script>
import webHeader from './menu'
import webFooter from './footer'

export default {
  components: {
    webHeader,
    webFooter
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.web-contain {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/main.vue